import React from "react";

// Full horizontal lockup (KB monogram + "KinBridge HEALTH AI"). Transparent PNG.
export const Logo = ({ className = "h-8", onDark = false, testid }) => {
  const img = (
    <img src="/kinbridge-logo.png" alt="KinBridge Health AI" className={`${className} w-auto`} data-testid={testid} />
  );
  return onDark ? (
    <span className="inline-flex items-center bg-white rounded-xl px-3 py-2 shadow-sm">{img}</span>
  ) : img;
};

// Compact KB monogram only.
export const LogoMark = ({ className = "h-9" }) => (
  <img src="/kinbridge-icon.png" alt="KinBridge Health" className={`${className} w-auto`} />
);
